import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Login } from './features/auth/Login';
import { Register } from './features/auth/Register';
import { Verify, RequestVerification } from './features/auth/Verify';
import { PasswordReset } from './features/auth/PasswordReset';
import { ForgotPassword } from './features/auth/ForgotPassword';
import { Settings } from './features/auth/Settings';
import { Feedback } from './features/auth/Feedback';
import { RoomWrapper, NewRoom, RoomSettings, RoomChat } from './features/rooms/Room';
import { RoomsList, RoomsWrapper } from './features/rooms/RoomList';
import Snackbar from './features/snackbar/Snackbar'
import { ProtectedRoute } from './common/ProtectedRoute';
import { Help } from './common/Help';
import  { HomeLayout } from './common/HomeLayout';
import { HomePage } from './common/HomePage';
import { ProtectedLayout } from './common/ProtectedLayout';
import { useListLanguagesQuery } from './app/services/languages/languagesService'
import CssBaseline from '@mui/material/CssBaseline'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import './App.css';

const theme = createTheme({
  message: {
    mine: '#134b9e'
  },
  palette: {
    mode: 'dark',
    background: {
      default: "#1D2026"
    }
  }
})

const App = () => {
  const { data } = useListLanguagesQuery()
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route element={<HomeLayout />}>
          <Route index element={<Login />} />
          <Route path='/register' element={<Register />} />
          <Route path='/request-verification' element={<RequestVerification />} />
          <Route path='/verify' element={<Verify />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/reset-password' element={<PasswordReset />} />
          <Route path='/login' element={<Login />} />
        </Route>
        <Route element={<ProtectedLayout />}>
          <Route path='/feedback' element={<Feedback />} />
          <Route path='/settings' element={<Settings />} />
          <Route path='/help' element={<Help />} />
          <Route path='/rooms' element={<RoomsWrapper />}>
            <Route index element={<RoomsList />} />
            <Route path='new' element={<NewRoom />} />
            <Route path=':id' element={<RoomWrapper />}>
              <Route index element={<RoomChat />} />
              <Route path='settings' element={<RoomSettings />} />
            </Route>
          </Route>
        </Route>
      </Routes>
      <Snackbar />
    </ThemeProvider>
  );
}

export default App;
